<mat-dialog-content data-test-id="dialog-message" tabindex="0" [innerHTML]="data.message"/>
@if (data.additionalContent) {
	<mat-list data-test-id="additional-content-list">
		@for (c of data.additionalContent; track c) {
			<mat-list-item tabindex="0"
	               data-test-id="additional-content-item">{{ c }}
	</mat-list-item>
		}
</mat-list>
}
<mat-dialog-actions>
	<button mat-stroked-button dialogFocus color="primary" [mat-dialog-close]="data" (mousedown)="agree(false, false)"
	        (keydown.enter)="agree(false, true)" data-test-id="dialog-false-button"
	        class="focus-inwards-dark">{{ data.label[1] }}
	</button>
	<button mat-flat-button color="primary" [mat-dialog-close]="data" (mousedown)="agree(true, false)"
	        (keydown.enter)="agree(true, true)" data-test-id="dialog-true-button"
	        class="focus-inwards-dark">{{ data.label[0] }}
	</button>
</mat-dialog-actions>
